<template>
  <div class="error-message text-center">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    message: {
      required: true,
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.error-message {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 30px;
  color: $color-text-primary;
  background-color: rgba(#000, 0.5);
  z-index: 1;

  &.middle {
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: transparent;
  }
}
</style>
